import { useMemo } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Widget } from "datastake-daf/dist/components";

const Style = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;

  h2 {
    font-size: 42px;
    font-weight: 700;
    margin-bottom: 0px;
    color: var(--base-gray-90);
  }
`;

export default function DataValue({ data = {}, loading }) {
  const { t } = useTranslation();

  const total = useMemo(() => {
    return Number(
      ((data?.documents?.datapoints || 0) + (data?.stakeholders?.datapoints || 0) + (data?.locations?.datapoints || 0) + (data?.events?.datapoints || 0)) / 100
    ).toLocaleString('en-us')
  }, [data]);

  return (
    <Widget
      loading={loading}
      title={t('Data Value')}
      className="with-border-header flex-1 h-w-btn-header"
    >
      <Style>
        <h2>$ {total}</h2>
      </Style>
    </Widget>
  );
}
